import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AddDeviceModalPage } from './add-device-modal.page';

const routes: Routes = [
  {
    path: '',
    component: AddDeviceModalPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AddDeviceModalPageRoutingModule {}
